<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<!-- @popoverTrigger is the trigger for the animation -->
<ng-container *ngIf="!contentTemplate">
  <div class="popover-container" @popoverTrigger>
    <div *ngIf="header" class="popover-header">{{ header }}</div>
    <div class="popover-content" [innerHTML]="convertString(text) | safeHtml"></div>
    <div *ngIf="footer" class="popover-footer">{{ footer }}</div>
  </div>
</ng-container>
<ng-container *ngIf="contentTemplate">
  <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: popoverData }"></ng-container>
</ng-container>
